__turbopack_context__.v({
  "video": "component-module__0Vb5-a__video",
});
